import React, { useState, useEffect, useRef } from 'react';
import DictionaryText from './DictionaryText';
import dot from '../../assets/icons/dot.svg';
import LanuageIcon from '../Common/icons/LanuageIcon'
import ArrowDownIcon from '../Common/icons/ArrowDownIcon'
import { buildLanguageSwitchUrl } from '../../utils/languageUtils';

const LanguageSelect = (props) => {
  const { options, className, currntLanguage } = props;
  const [open, setOpen] = useState(false);

  const onOpen = () => {
    setOpen((state) => !state);
  };

  const dropdownRef = useRef(null);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
        }
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <div ref={dropdownRef} className="relative w-fit">
      <div onClick={onOpen} className="relative flex items-center justify-start gap-2 cursor-pointer max-h-full">
        <LanuageIcon
          className={`${className}`}
        />
        <ArrowDownIcon
          className={`transition-all duration-500 duration ${className} ${!open ? 'rotate-180' : 'rotate-0'}`}
        />
      </div>
      {open && (
        <div className="absolute z-30 py-2 mt-2.5 p-5 bg-white">
          <div className="w-full select-dropdown h-full max-h-[125px]">
            {options
              .filter((item) => item.name !== currntLanguage)
              .map((item, index) => {
               const languageSwitchUrl = buildLanguageSwitchUrl(item.url, item.name);
                return (
                  <a key={index} href={languageSwitchUrl}>
                    <div className="select-none text-lg hover:font-bold font-medium leading-[28px] pb-1 transition-all duration-500 duration flex gap-2">
                      <img src={dot} className="" alt="dot" />
                      <DictionaryText dictionaryKey={item.name} />
                    </div>
                  </a>
                );
              })}
          </div>
        </div>
      )}
    </div>
  );
};

export default LanguageSelect;

